import React, { useEffect, useState } from "react";
import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import ErrorMessage from "../../../components/TableBionovaQ/ErrorMessage/ErrorMessage";
import InputQ from "../../../components/FormComponents/InputQ/InputQ";
import request from "../../../utils/request";
import styles from "./AreasForm.module.css";
import ColorSelect from "../../../components/FormComponents/ColorSelect/ColorSelect";
import { toast } from "react-toastify";

const AreasForm = ({
  formData,
  handleFormData,
  handleClose,
  open,
  locale,
  t,
  getAreas,
}) => {
  const [error, setError] = useState("");
  const [validate, setValidate] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [colors, setColors] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setValidate(true);
      return;
    }

    try {
      const bodyRequest = { ...formData };
      if (formData.id) {
        await request().put("/api/Area", bodyRequest);
      } else {
        await request().post("/api/Area", bodyRequest);
      }
      handleClose();
      setError("");

      getAreas();
    } catch (err) {
      setError(err.response?.data?.message || "Error al guardar ubicación.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    handleFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onClose = () => {
    handleClose();
    setError("");
    setValidate(false);
  };

  const getColors = async () => {
    try {
      let res = await request().get(`/api/parameter/color`);

      setColors(res.data);
    } catch (e) {
      toast.error(e.response?.data?.messagge);
    }
  };
  useEffect(() => {
    getColors();
  }, []);
  const handleColor = (value) => {
    handleFormData((prevData) => ({ ...prevData, colorId: value.colorId }));
  };

  return (
    <ModalQ
      open={open}
      title={
        !formData.id
          ? t("NewArea", locale) || "New Area"
          : t("EditArea", locale) || "Edit Area"
      }
      handleClose={onClose}
    >
      {error && <ErrorMessage message={error} />}
      <div className={styles.container}>
        <div className={styles.inputGroup}>
          <InputQ
            containerWidth={"48%"}
            labelTop={true}
            label={t("NameSpan", locale) || "Name"}
            name="name"
            handleChange={handleInputChange}
            value={formData.name}
            required={true}
            validate={validate}
            leftMessage={true}
          />
          <div style={{ width: "50%" }}>
            <ColorSelect
              label="Color"
              value={formData.colorId}
              onChange={handleColor}
              options={colors}
            />
          </div>
        </div>

        <button
          className={`${styles.button} ${styles.confirmButton}`}
          onClick={handleSubmit}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "Confirm"}
        </button>
      </div>
    </ModalQ>
  );
};

export default AreasForm;
